import { eachDayOfInterval, endOfMonth, endOfWeek, startOfMonth, startOfToday, startOfWeek } from '@repo/date-time';
import { mapDateToCalendarDay } from '../../calendarCore/utils/mapDateToCalendarDay';
export function getMonthCalendarDays({ forDate, minDate, maxDate, flaggedDates, selectionStart, selectionEnd, }) {
    const today = startOfToday();
    return eachDayOfInterval({
        start: startOfWeek(startOfMonth(forDate), { weekStartsOn: 1 }),
        end: endOfWeek(endOfMonth(forDate), { weekStartsOn: 1 }),
    }).map((date) => mapDateToCalendarDay({ date, flaggedDates, today, minDate, maxDate, selectionStart, selectionEnd }));
}
